module.exports = "<div id=\"wave\">\n  <span ng-bind=\"'Počkej chvíli' | translate\"></span>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/utility/loader/loader.html
 ** module id = 246
 ** module chunks = 0
 **/